import { Component, OnInit } from '@angular/core';
import { CodaltComponent } from '../../codalt.component';
import { CustomerProject } from '../../customer-project.interface';
import { LocalStorage } from '../../local-storage.class';
import { ConfirmDialogService } from '../../services/confirm-dialog-service/confirm-dialog.service';
import { CustomerProjectService } from '../../services/customer-project/customer-project.service';
import { CustomerService } from '../../services/customer/customer.service';
import { PageTitleService } from '../../services/page-title/page-title.service';
import { SearchService } from '../../services/search/search.service';
import { Utils } from '../../utils.class';
import { Contact } from '../shared/contact';

@Component({
    selector: 'app-contact-overview',
    templateUrl: './contact-overview.component.html',
    styleUrls: ['./contact-overview.component.scss'],
    standalone: false,
})
export class ContactOverviewComponent extends CodaltComponent implements OnInit {
    public Utils = Utils;
    public LocalStorage = LocalStorage;

    contacts: Contact[];
    loading = true;
    customerId: number;
    projectId: number;
    private allContacts: Contact[];
    projects: CustomerProject[];

    constructor(
        private customerService: CustomerService,
        private confirmDialogService: ConfirmDialogService,
        private searchService: SearchService,
        private customerProjectService: CustomerProjectService,
        private pageTitleService: PageTitleService
    ) {
        super();
    }

    ngOnInit() {
        this.pageTitleService.setTitle('Contactpersonen');
        this.watchRouteParams(
            [this.RouteParamnames.customerId, this.RouteParamnames.projectId],
            ({ customerId, projectId }) => {
                this.customerId = +customerId;
                this.projectId = +projectId;
                // Klantgebied uit de route eerst in LocalStorage: de interceptor stuurt daaruit
                // current_customer_id mee, waarop getProject() en getProjects() filteren.
                this.subscriptions.add(
                    this.customerService.getSingle(this.customerId).subscribe(customer => {
                        LocalStorage.setCustomer(customer);
                        this.pageTitleService.setTitle('Contactpersonen', customer.customer_name);

                        if (this.projectId) {
                            this.subscriptions.add(
                                this.customerProjectService.getProject(this.projectId).subscribe(project => {
                                    this.projects = [project.data];
                                    if (project.data?.name) {
                                        this.pageTitleService.setTitle('Contactpersonen', project.data.name);
                                    }
                                })
                            );
                            this.subscriptions.add(
                                this.customerService.contacts(this.projectId).subscribe(
                                    contacts => {
                                        this.loading = false;
                                        this.allContacts = this.contacts = contacts;
                                        this.filterAndSort();
                                    },
                                    error =>
                                        this.confirmDialogService.confirm('Kon contactpersonen niet ophalen', error)
                                )
                            );
                        } else {
                            this.subscriptions.add(
                                this.customerProjectService
                                    .getProjects(true, null, null, null, true)
                                    .subscribe(projects => {
                                        this.loading = false;
                                        this.projects = projects;
                                    })
                            );
                        }
                    })
                );
            }
        );

        this.subscriptions.add(this.searchService.change.subscribe(searchValue => this.filterAndSort(searchValue)));
    }

    filterAndSort(searchValue?: string) {
        let contacts = this.allContacts;
        if (!contacts) {
            return;
        }
        if (searchValue) {
            contacts = contacts.filter(c => {
                return (
                    c.description.toLowerCase().indexOf(searchValue) !== -1 ||
                    c.name.toLowerCase().indexOf(searchValue) !== -1 ||
                    c.email.toLowerCase().indexOf(searchValue) !== -1
                );
            });
        }
        this.contacts = contacts.sort(function (a, b) {
            const nameA = a['name'].toUpperCase(); // ignore upper and lowercase
            const nameB = b['name'].toUpperCase(); // ignore upper and lowercase
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            // names must be equal
            return 0;
        });
    }
}
